'use strict';

const _ = require('underscore');
const Backbone = require('backbone');
const Member = require('common/domain/entity/project-member');

module.exports = Backbone.Collection.extend({
    model: Member,

    comparator: function(member) {
        return member.getUser().getName().toLowerCase();
    },

    getMemberByUser: function(user) {
        if(!user) {
            return null;
        }

        return this.find(m => {
            return m && (_.isString(user) || _.isNumber(user) ?
                m.getUser().id.toString() == user.toString() :
                m.getUser().id == user.id);
        });
    },

    getMembersByUserId: function(ids) {
        return this.filter(function(m) {
            return _.contains(ids, m.getUser().id.toString());
        });
    },

    findByQuery: function(query, options) {
        const exact = options && options.exact == true;
        return this.filter(function(model){
            if(model.isSuspended()) {
                return false;
            }

            if(query == '') {
                return true;
            }
            else if(exact) {
                return model.getUser().getName().toLowerCase() == query;
            } else {
                return _.some(model.getUser().getName().split(/\s+/),
                    function(nwords) {
                        return nwords.toLowerCase().indexOf(
                                query.toLowerCase()
                            ) == 0;
                    });
            }
        });
    },
});



// WEBPACK FOOTER //
// ./common/domain/collection/project-member.js